import { Config } from "../config";
import { useApi } from "../composables/useApi";

export const useStorageApi = useApi((args) => ({
  ...(args || {}),
  baseURL: Config.storageUrl,
}));
